import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  EventEmitter,
  Output,
  ɵConsole,
  ChangeDetectorRef,
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { Observable, from, Subscription } from "rxjs";
import { concatMap, filter, toArray, take, map } from "rxjs/operators";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { CatalogoService } from "src/app/services/catalogo.service";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { Obra } from "src/app/models/entities/obra";
import { MapUtils } from "src/app/shared/utils/map-utils";
import { AgmMap, AgmMarker, MapsAPILoader } from "@agm/core";
import { ObraService } from "src/app/services/obra.service";
import { Estado } from "src/app/models/entities/estado";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { InfoWindow } from "@agm/core/services/google-maps-types";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { SegmentoService } from "src/app/services/segmento.service";
import { Segmento } from "src/app/models/entities/segmento";
import { LevantamientoSeleccionadoDTO } from "src/app/models/dtos/levantamiento-seleccionado-dto";
import { Coordenada } from "src/app/models/entities/coordenada";
import { CapaSegmentosDTO } from "src/app/models/dtos/capa-segmentos-dto";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { KmlUtils } from "src/app/shared/utils/kml-utils";
import { InteraccionMapaService } from "src/app/services/interaccion-mapa.service";
import { Router } from "@angular/router";
import { AvanceDTO } from "src/app/models/dtos/avance-dto";
import { Usuario } from "src/app/models/entities/usuario";
import { UsuarioService } from "src/app/services/usuario.service";
import { LoaderService } from "src/app/services/loader.service";
import { EstadoRouteService } from "src/app/services/estado-route.service";
import { Places } from "../../../../shared/utils/places-utils";
import { PlacesCoordinatesService } from "../../../../services/places-coordinates.service";

@Component({
  selector: "busqueda-obras-proceso",
  templateUrl: "./busqueda-obras-proceso.component.html",
  styleUrls: ["./busqueda-obras-proceso.component.scss"],
})
export class BusquedaObrasProcesoComponent implements OnInit, OnDestroy {
  @Output()
  markerClick: EventEmitter<AgmMarker> = new EventEmitter<AgmMarker>();
  @ViewChild(AgmMap)
  public mapa: AgmMap;
  public buscadorForm: FormGroup = null;
  public catDireccionesAdjuntas: ElementoCatalogo[] = null;
  public catEstados: Estado[] = [];
  public obras$: Observable<LevantamientoObra[]>;
  public obrasInformacion$: Observable<ObraDTO[]>;
  public levantamientosObrasFiltradas: LevantamientoObra[] = [];

  public mostrarMapaObras: boolean = false;
  public catCapas: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];
  public catSecciones: ElementoCatalogo[];
  public catCarpetas: ElementoCatalogo[];
  public catTipoLevantamiento: ElementoCatalogo[];
  public catTipoObra: ElementoCatalogo[];
  public catPrioridades: ElementoCatalogo[];
  public elementosObra: LevantamientoSeleccionadoDTO;
  public datosObra: LevantamientoSeleccionadoDTO;
  public map: any;
  public mostrarProyecto: boolean = true;
  public mostrarAvance: boolean = true;
  public mostrarCompletado: boolean = true;
  public mostrarEstructuras: boolean = true;
  public mostrarPendiente: boolean = true;

  public tipoConsulta: string = "";
  public obrasLevantamientos: LevantamientoObra[] = [];
  public obras: Obra[] = [];
  public informacionObras: ObraDTO[] = [];
  public informacionObrasLevantamiento: LevantamientoObra[] = [];
  public informacionObrasLevantamientoCopia: LevantamientoObra[] = [];
  public totalObras: number = 0;
  public totalObrasPrioritarias: number = 0;
  public totalObrasCompromiso: number = 0;
  public totalObrasCONAGO: number = 0;
  public totalObrasFONADIN: number = 0;
  public metaTotal: number = 0;
  public inversionTotal: number = 0;
  public obraMarkerSeleccionada: ObraDTO[] = [];
  public mostrarInformacionEnInfowindow: boolean = false;
  public anioActual = new Date().getFullYear();

  public readonly CAMINOS_RURALES: string = "0";
  public readonly CARRETERAS_FEDERALES: string = "1";
  public readonly OBRA_EN_PROCESO: string = "0";
  public readonly OBRA_PRIORITARIA: string = "1";
  public readonly OBRA_COMPROMISO: string = "0";
  public readonly OBRA_CONAGO: string = "3";
  public readonly OBRA_F0NADIN: string = "4";
  public readonly ORIGEN_RECURSOS_FONADIN: string = "1";
  public readonly CAPA_PROYECTO_PROCESO: string = "0";
  public readonly CAPA_PROYECTO_PLANEACION: string = "4";
  public readonly CAPA_META_ACTUAL: string = "1";
  public readonly CAPA_COMPLETADO: string = "2";
  public readonly CAPA_ESTRUCTURA: string = "5";
  public readonly KEY_COLOR_CAPA_COMPLETADO: string = "2";
  public COLOR_PARA_RESALTAR: string = "#e80000";

  public latitudMapa: number = 0;
  public longitudMapa: number = 0;
  public zoomMapa: number = 0;
  public marker: any = {
    url: "../../../../../assets/img/iconos/marker-red.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public markerFederales: any = {
    url: "../../../../../assets/img/iconos/marker-black.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public markerFonadin: any = {
    url: "../../../../../assets/img/iconos/marker-capa-proyecto-planeacion.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public markerDesdoblamiento: any = {
    url: "../../../../../assets/img/iconos/marker-capa-proyecto-proceso.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public markerSeleccionado: any = {
    url: "../../../../../assets/img/iconos/marker-blue.png",
    scaledSize: {
      width: 75,
      height: 75,
    },
  };
  public iconoMultimedia: any = {
    url: "../../../../../assets/img/iconos/icono-multimedia.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public iconoPuente: any = {
    url: "../../../../../assets/img/iconos/icono-puente.png",
    scaledSize: {
      width: 25,
      height: 25,
    },
  };
  public iconoCoordenada: any = {
    url: "../../../../../assets/img/iconos/coordenada-disponible.png",
    scaledSize: {
      width: 5,
      height: 5,
    },
  };

  public iconoInicioFin: any;

  public hexColorCapaCompletado: string = "";
  public coordenadaInicial: Coordenada;
  public coordenadaFinal: Coordenada;
  public coordenadaInfoWindow: Coordenada;
  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto = false;
  public valorCheckbox: boolean = true;
  public colorSegmentosSeleccionados: string = "";
  public avanceSeleccionado: AvanceDTO;

  public suscripcionPolylines: Subscription;
  public archivosSeleccionados: ArchivoCoordenada[];

  public mostrarCarreterasFederales: boolean = true;
  public mostrarCaminosRurales: boolean = true;
  public mostrarObrasFonadin: boolean = false;

  paths = [];
  blue = "#000099";
  red = "#838383";
  @ViewChild("modalGaleria")
  public modalGaleria: NgbModalRef;
  public refModalGaleria: NgbModalRef;

  public obrasCargadas: boolean = false;

  public detalleObraProceso$: Observable<boolean>;
  newArray = [];

  constructor(
    private formBuilder: FormBuilder,
    private facadeSesionService: FacadeSesionService,
    private catalogoService: CatalogoService,
    private levantamientoObraService: LevantamientoObraService,
    private mapUtils: MapUtils,
    private placeUtils: Places,
    private kmlUtils: KmlUtils,
    private obraService: ObraService,
    private capaService: CapaService,
    private segmentoService: SegmentoService,
    private archivoCoordenadaService: ArchivoCoordenadaService,
    private ngbModalService: NgbModal,
    private cd: ChangeDetectorRef,
    private usuarioService: UsuarioService,
    private mapsAPILoader: MapsAPILoader,
    private loaderService: LoaderService,
    private estadoRouteService: EstadoRouteService,
    private placesCordinatesService: PlacesCoordinatesService
  ) {}

  async ngOnInit() {
    this.detalleObraProceso$ =
      this.estadoRouteService.detalleObraProceso$.asObservable();
    this.detalleObraProceso$.subscribe(
      (mapaObras) => (this.mostrarMapaObras = mapaObras)
    );
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Búsqueda de obras en proceso"
    );
    await this.obtenerCatalogos();
    await this.obtenerInformacionInicialPanel();
    this.inicializarForm();
    // this.placeUtils.paises.forEach((pais) => {
    //   let paths = this.placesCordinatesService.buildCoordinatesArrayFromString(
    //     pais.coordenadas
    //   );
    //   this.newArray.push({ nombre: pais.nombre, coordenadas: paths });
    // });
    // console.log(this.informacionObrasLevantamiento);
    // console.log(this.informacionObras);
  }

  //TODO: Implementación del polígono
  // ngAfterContentInit() {
  //   this.paths = this.placesCordinatesService.buildCoordinatesArrayFromString(
  //     this.placeUtils.aguascalientes
  //   );
  // }

  public async obtenerInformacionInicialPanel() {
    await this.obtenerInformacionObras();
    this.totalObrasPrioritarias = this.informacionObras.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatTipoPrioridad === this.OBRA_PRIORITARIA
    ).length;
    this.totalObrasCompromiso = this.informacionObras.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatTipoPrioridad === this.OBRA_COMPROMISO
    ).length;
    this.totalObrasCONAGO = this.informacionObras.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatTipoPrioridad === this.OBRA_CONAGO
    ).length;
    this.totalObrasFONADIN = this.informacionObras.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatOrigenRecursos === this.ORIGEN_RECURSOS_FONADIN
    ).length;
    this.metaTotal = this.informacionObras.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.inversionTotal = this.informacionObras.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );

    await this.obtenerInformacionLevantamientoObras();
    this.totalObras = this.informacionObrasLevantamiento.length;
  }

  public inicializarMapa() {
    this.latitudMapa = this.mapUtils.LATITUD_PAIS_MEXICO;
    this.longitudMapa = this.mapUtils.LONGITUD_PAIS_MEXICO;
    this.zoomMapa = this.mapUtils.ZOOM_PAIS_MEXICO;
  }

  public cambioZoom(zoom: number) {
    this.zoomMapa = zoom;
  }

  public inicializarForm(): void {
    this.buscadorForm = this.formBuilder.group({
      keyDireccionAdjunta: new FormControl("-1"),
      keyPrioridad: new FormControl("-1"),
      keyEstado: new FormControl("-1"),
      keyObra: new FormControl("-1"),
    });

    this.buscadorForm.get("keyObra").disable();
    this.buscadorForm
      .get("keyDireccionAdjunta")
      .valueChanges.subscribe((keyDireccionAdjunta: string) => {
        if (keyDireccionAdjunta === "-1") {
        } else {
          this.estadoRouteService.detalleObraProceso$.next(false);
          this.obtenerInformacionPorDireccion(keyDireccionAdjunta);
          this.buscadorForm.get("keyEstado").setValue("-1");
        }
      });

    this.buscadorForm
      .get("keyPrioridad")
      .valueChanges.subscribe((keyPrioridad: string) => {
        if (keyPrioridad === "-1") {
          let obras = this.informacionObras;
          let obrasLevantamiento = this.informacionObrasLevantamiento;

          let keyEstado: string = this.buscadorForm.get("keyEstado").value;
          if (keyEstado !== "-1") {
            obrasLevantamiento = obrasLevantamiento.filter(
              (l: LevantamientoObra) => l.keyCatEstado === keyEstado
            );
            let { lat, lng }: Estado = this.catEstados.find(
              (estado: Estado) => estado.key === keyEstado
            );
            this.latitudMapa = lat;
            this.longitudMapa = lng;
            this.zoomMapa = 8;
          } else {
            this.inicializarMapa();
          }
          let obrasConFicha: ObraDTO[] = [];
          for (let i = 0; i < obrasLevantamiento.length; i++) {
            for (let index = 0; index < obras.length; index++) {
              if (
                obras[index].obra.keyLevantamientoObra ===
                obrasLevantamiento[i].key
              ) {
                obrasConFicha.push(obras[index]);
              }
            }
          }
          this.totalObras = obrasLevantamiento.length;
          this.totalObrasPrioritarias = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === this.OBRA_PRIORITARIA
          ).length;
          this.totalObrasCompromiso = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === this.OBRA_COMPROMISO
          ).length;
          this.totalObrasCONAGO = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === this.OBRA_CONAGO
          ).length;
          this.totalObrasFONADIN = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatOrigenRecursos ===
              this.ORIGEN_RECURSOS_FONADIN
          ).length;
          this.metaTotal = obrasConFicha.reduce(
            (prev, curr) => prev + curr.obra.longitudTotal,
            0
          );
          this.inversionTotal = obrasConFicha.reduce(
            (prev, curr) => prev + curr.obra.inversionTotal,
            0
          );
        } else {
          this.estadoRouteService.detalleObraProceso$.next(false);
          this.obtenerInformacionPorPrioridad(keyPrioridad);
        }
      });

    this.buscadorForm
      .get("keyEstado")
      .valueChanges.subscribe((keyEstado: string) => {
        if (keyEstado === "-1") {
          this.inicializarMapa();
          this.buscadorForm.get("keyObra").setValue("-1");
          this.buscadorForm.get("keyObra").disable();
        } else {
          this.estadoRouteService.detalleObraProceso$.next(false);
          this.buscadorForm.get("keyObra").enable();
          this.obtenerInformacionPorEstado(
            this.buscadorForm.get("keyPrioridad").value,
            this.buscadorForm.get("keyDireccionAdjunta").value,
            keyEstado
          );
          let { lat, lng }: Estado = this.catEstados.find(
            (estado: Estado) => estado.key === keyEstado
          );
          this.latitudMapa = lat;
          this.longitudMapa = lng;
          this.zoomMapa = 8;
          this.buscadorForm.get("keyObra").setValue("-1");
          this.levantamientosObrasFiltradas =
            this.informacionObrasLevantamiento.filter(
              (obras: LevantamientoObra) => obras.keyCatEstado === keyEstado
            );
        }
      });

    this.buscadorForm
      .get("keyObra")
      .valueChanges.subscribe((keyObra: string) => {
        if (keyObra === "-1") {
        } else {
          this.estadoRouteService.detalleObraProceso$.next(false);
          this.obtenerInformacionPanelObra(keyObra);
          let { latitud, longitud }: LevantamientoObra =
            this.informacionObrasLevantamiento.find(
              (obra: LevantamientoObra) => obra.key === keyObra
            );
          this.latitudMapa = latitud;
          this.longitudMapa = longitud;
          this.zoomMapa = 11;
        }
      });
  }

  public obtenerInformacionPorDireccion(keyDireccionAdjunta: string) {
    let obras = this.informacionObras;
    let obrasLevantamiento = this.informacionObrasLevantamiento;
    let obrasLevantamientoDireccion = obrasLevantamiento;
    let keyCatEstado: string = this.buscadorForm.get("keyEstado").value;
    let keyPrioridad: string = this.buscadorForm.get("keyPrioridad").value;
    if (keyCatEstado !== "-1") {
      obrasLevantamientoDireccion = obrasLevantamiento.filter(
        (obrasLevantamiento: LevantamientoObra) =>
          obrasLevantamiento.keyCatEstado === keyCatEstado
      );
    }
    this.totalObras = obrasLevantamientoDireccion.length;
    let obrasConFicha: ObraDTO[] = [];
    for (let i = 0; i < obrasLevantamientoDireccion.length; i++) {
      for (let index = 0; index < obras.length; index++) {
        if (
          obras[index].obra.keyLevantamientoObra ===
          obrasLevantamientoDireccion[i].key
        ) {
          obrasConFicha.push(obras[index]);
        }
      }
    }
    if (keyPrioridad !== "-1") {
      switch (keyPrioridad) {
        //COMPROMISO
        case "0":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === keyPrioridad
          ).length;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //PRIORITARIA
        case "1":
          this.totalObrasPrioritarias = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === keyPrioridad
          ).length;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //NORMAL
        case "2":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //CONAGO
        case "3":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === keyPrioridad
          ).length;
          this.totalObrasFONADIN = 0;
          break;
        //CABECERAS DE OAXACA
        case "4":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //FONADIN
        case "5":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatOrigenRecursos ===
              this.ORIGEN_RECURSOS_FONADIN
          ).length;
          break;
      }
    } else {
      this.totalObrasPrioritarias = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatTipoPrioridad === this.OBRA_PRIORITARIA
      ).length;
      this.totalObrasCompromiso = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatTipoPrioridad === this.OBRA_COMPROMISO
      ).length;
      this.totalObrasCONAGO = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatTipoPrioridad === this.OBRA_CONAGO
      ).length;
      this.totalObrasFONADIN = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatOrigenRecursos === this.ORIGEN_RECURSOS_FONADIN
      ).length;
    }
    this.metaTotal = obrasConFicha.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.inversionTotal = obrasConFicha.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );
  }

  public obtenerInformacionPorPrioridad(keyPrioridad: string) {
    let obras = this.informacionObras;
    let obrasLevantamiento = this.informacionObrasLevantamiento;
    let obrasLevantamientoDireccion = obrasLevantamiento;
    let keyCatEstado: string = this.buscadorForm.get("keyEstado").value;
    if (keyCatEstado !== "-1") {
      obrasLevantamientoDireccion = obrasLevantamiento.filter(
        (obrasLevantamiento: LevantamientoObra) =>
          obrasLevantamiento.keyCatEstado === keyCatEstado
      );
    }
    this.totalObras = obrasLevantamientoDireccion.length;
    let obrasConFicha: ObraDTO[] = [];
    for (let i = 0; i < obrasLevantamientoDireccion.length; i++) {
      for (let index = 0; index < obras.length; index++) {
        if (
          obras[index].obra.keyLevantamientoObra ===
          obrasLevantamientoDireccion[i].key
        ) {
          obrasConFicha.push(obras[index]);
        }
      }
    }
    switch (keyPrioridad) {
      //COMPROMISO
      case "0":
        this.totalObrasPrioritarias = 0;
        this.totalObrasCompromiso = obrasConFicha.filter(
          (informacion: ObraDTO) =>
            informacion.obra.keyCatTipoPrioridad === keyPrioridad
        ).length;
        this.totalObrasCONAGO = 0;
        this.totalObrasFONADIN = 0;
        break;
      //PRIORITARIA
      case "1":
        this.totalObrasPrioritarias = obrasConFicha.filter(
          (informacion: ObraDTO) =>
            informacion.obra.keyCatTipoPrioridad === keyPrioridad
        ).length;
        this.totalObrasCompromiso = 0;
        this.totalObrasCONAGO = 0;
        this.totalObrasFONADIN = 0;
        break;
      //NORMAL
      case "2":
        this.totalObrasPrioritarias = 0;
        this.totalObrasCompromiso = 0;
        this.totalObrasCONAGO = 0;
        this.totalObrasFONADIN = 0;
        break;
      //CONAGO
      case "3":
        this.totalObrasPrioritarias = 0;
        this.totalObrasCompromiso = 0;
        this.totalObrasCONAGO = obrasConFicha.filter(
          (informacion: ObraDTO) =>
            informacion.obra.keyCatTipoPrioridad === keyPrioridad
        ).length;
        this.totalObrasFONADIN = 0;
        break;
      //CABECERAS DE OAXACA
      case "4":
        this.totalObrasPrioritarias = 0;
        this.totalObrasCompromiso = 0;
        this.totalObrasCONAGO = 0;
        this.totalObrasFONADIN = 0;
        break;
      //FONADIN
      case "5":
        this.totalObrasPrioritarias = 0;
        this.totalObrasCompromiso = 0;
        this.totalObrasCONAGO = 0;
        this.totalObrasFONADIN = obrasConFicha.filter(
          (informacion: ObraDTO) =>
            informacion.obra.keyCatOrigenRecursos ===
            this.ORIGEN_RECURSOS_FONADIN
        ).length;
        break;
    }
    this.metaTotal = obrasConFicha.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.inversionTotal = obrasConFicha.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );
  }

  public obtenerInformacionPorEstado(
    keyPrioridad: string,
    keyDireccionAdjunta: string,
    keyEstado: string
  ) {
    let obras = this.informacionObras;
    let obrasLevantamiento = this.informacionObrasLevantamiento;
    let obrasLevantamientoFiltradas: LevantamientoObra[] = [];
    let obrasConFicha: ObraDTO[] = [];
    if (keyDireccionAdjunta !== "-1") {
      obrasLevantamientoFiltradas = obrasLevantamiento.filter(
        (obrasDireccion: LevantamientoObra) =>
          obrasDireccion.keyCatDireccionAdjunta === keyDireccionAdjunta
      );
      obrasLevantamientoFiltradas = obrasLevantamientoFiltradas.filter(
        (obrasEstado: LevantamientoObra) =>
          obrasEstado.keyCatEstado === keyEstado
      );
    } else {
      obrasLevantamientoFiltradas = obrasLevantamiento.filter(
        (obrasEstado: LevantamientoObra) =>
          obrasEstado.keyCatEstado === keyEstado
      );
    }
    for (let i = 0; i < obrasLevantamientoFiltradas.length; i++) {
      for (let index = 0; index < obras.length; index++) {
        if (
          obras[index].obra.keyLevantamientoObra ===
          obrasLevantamientoFiltradas[i].key
        ) {
          obrasConFicha.push(obras[index]);
        }
      }
    }
    if (keyPrioridad !== "-1") {
      switch (keyPrioridad) {
        //COMPROMISO
        case "0":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === keyPrioridad
          ).length;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //PRIORITARIA
        case "1":
          this.totalObrasPrioritarias = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === keyPrioridad
          ).length;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //NORMAL
        case "2":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //CONAGO
        case "3":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatTipoPrioridad === keyPrioridad
          ).length;
          this.totalObrasFONADIN = 0;
          break;
        //CABECERAS DE OAXACA
        case "4":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = 0;
          break;
        //FONADIN
        case "5":
          this.totalObrasPrioritarias = 0;
          this.totalObrasCompromiso = 0;
          this.totalObrasCONAGO = 0;
          this.totalObrasFONADIN = obrasConFicha.filter(
            (informacion: ObraDTO) =>
              informacion.obra.keyCatOrigenRecursos ===
              this.ORIGEN_RECURSOS_FONADIN
          ).length;
          break;
      }
    } else {
      this.totalObras = obrasLevantamientoFiltradas.length;
      this.totalObrasPrioritarias = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatTipoPrioridad === this.OBRA_PRIORITARIA
      ).length;
      this.totalObrasCompromiso = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatTipoPrioridad === this.OBRA_COMPROMISO
      ).length;
      this.totalObrasCONAGO = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatTipoPrioridad === this.OBRA_CONAGO
      ).length;
      this.totalObrasFONADIN = obrasConFicha.filter(
        (informacion: ObraDTO) =>
          informacion.obra.keyCatOrigenRecursos === this.ORIGEN_RECURSOS_FONADIN
      ).length;
    }
    this.metaTotal = obrasConFicha.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.inversionTotal = obrasConFicha.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );
  }

  public obtenerInformacionPanelObra(keyObra: string) {
    let obras = this.informacionObras;
    let obraSeleccionada: ObraDTO[] = [];
    obraSeleccionada = obras.filter(
      (obra: ObraDTO) => obra.obra.keyLevantamientoObra === keyObra
    );
    this.totalObras = 1;
    this.totalObrasPrioritarias = obraSeleccionada.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatTipoPrioridad === this.OBRA_PRIORITARIA
    ).length;
    this.totalObrasCompromiso = obraSeleccionada.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatTipoPrioridad === this.OBRA_COMPROMISO
    ).length;
    this.totalObrasCONAGO = obraSeleccionada.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatTipoPrioridad === this.OBRA_CONAGO
    ).length;
    this.totalObrasFONADIN = obraSeleccionada.filter(
      (informacion: ObraDTO) =>
        informacion.obra.keyCatOrigenRecursos === this.ORIGEN_RECURSOS_FONADIN
    ).length;
    this.metaTotal = obraSeleccionada.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.inversionTotal = obraSeleccionada.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );
  }

  public mapaCargado(event: any): void {
    this.mapa = event;
    this.inicializarMapa();
  }

  public filtroDireccionAdjunta(event: any, keyDireccionAdjunta: string) {
    if (event === true) {
      this.informacionObrasLevantamiento =
        this.informacionObrasLevantamiento.concat(
          this.informacionObrasLevantamientoCopia.filter(
            (f) => f.keyCatDireccionAdjunta === keyDireccionAdjunta
          )
        );
      this.obtenerInformacionPorDireccion(keyDireccionAdjunta);
    } else {
      this.informacionObrasLevantamiento =
        this.informacionObrasLevantamiento.filter(
          (f) => f.keyCatDireccionAdjunta !== keyDireccionAdjunta
        );
      if (keyDireccionAdjunta === "1") {
        keyDireccionAdjunta = "0";
      } else {
        keyDireccionAdjunta = "1";
      }
      this.obtenerInformacionPorDireccion(keyDireccionAdjunta);
    }
  }

  public obtenerMarker(obra: LevantamientoObra) {
    if (this.buscadorForm.get("keyObra").value === obra.key) {
      return this.markerSeleccionado;
    } else {
      if (obra) {
        let obra2 = this.informacionObras.find(
          (data) => data.obra.keyLevantamientoObra === obra.key
        );
        if (obra2 === undefined) {
          if (obra.keyCatDireccionAdjunta === this.CAMINOS_RURALES) {
            return this.marker;
          } else {
            return this.markerFederales;
          }
        } else {
          if (obra2.obra.keyCatTipoPrioridad === "5") {
            return this.markerFonadin;
          } else if (obra2.obra.keyCatTipoPrioridad === "6") {
            return this.markerDesdoblamiento;
          } else {
            if (obra.keyCatDireccionAdjunta === this.CAMINOS_RURALES) {
              return this.marker;
            } else {
              return this.markerFederales;
            }
          }
        }
      }
    }
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catDireccionesAdjuntas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(take(1))
      .toPromise();
    this.catEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    this.catSubElementos = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS)
      .pipe(take(1))
      .toPromise();
    this.catColores = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES)
      .pipe(take(1))
      .toPromise();
    this.catCapas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS)
      .pipe(take(1))
      .toPromise();
    this.catCarpetas = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CARPETAS)
      .pipe(take(1))
      .toPromise();
    this.catSecciones = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SECCIONES)
      .pipe(take(1))
      .toPromise();
    this.catTipoLevantamiento = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS)
      .pipe(take(1))
      .toPromise();
    this.catTipoObra = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    this.catPrioridades = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD)
      .pipe(take(1))
      .toPromise();
  }

  public async obtenerInformacionObras(): Promise<any> {
    // let catalogoTipoObra: ElementoCatalogo[] = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    // let catalogoPrioridad: ElementoCatalogo[] = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD).pipe(take(1)).toPromise();
    // let estados: Estado[] = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
    this.tipoConsulta =
      await this.facadeSesionService.usuarioEnSesionService.obtenerKeyTipoObra();
    this.obras = await this.obraService.findAll().pipe(take(1)).toPromise();
    this.obrasLevantamientos = await this.levantamientoObraService
      .findAll()
      .pipe(take(1))
      .toPromise();
    for (let index = 0; index < this.obras.length; index++) {
      let obra = this.obras[index];
      let keyLevObra = this.obras[index].keyLevantamientoObra;
      let levObra = this.obrasLevantamientos.find(
        (l: LevantamientoObra) => l.key === keyLevObra
      );
      let keyTipoPrioridad = obra.keyCatTipoPrioridad;
      let keyTipoObra = levObra.keyCatTipoObra;
      let keyEstado = levObra.keyCatEstado;
      let obraDto: ObraDTO = {
        nombreEstado: this.catEstados.find((e: Estado) => e.key === keyEstado)
          .nombre,
        nombreObra: levObra.nombreObra,
        nombreTipoObra: this.catTipoObra.find(
          (c: ElementoCatalogo) => c.key === keyTipoObra
        ).nombre,
        nombreTipoPrioridad: this.catPrioridades.find(
          (c: ElementoCatalogo) => c.key === keyTipoPrioridad
        ).nombre,
        nombreTramoLicitacion: levObra.nombreTramoLicitacion,
        keyCatDireccionAdjunta: levObra.keyCatDireccionAdjunta,
        obra,
      };
      this.informacionObras.push(obraDto);
    }
  }

  public async obtenerInformacionLevantamientoObras() {
    this.informacionObrasLevantamiento = await this.levantamientoObraService
      .findAprobados()
      .pipe(
        take(1),
        map((levantamientoObra: LevantamientoObra[]) =>
          levantamientoObra.filter(
            (obra: LevantamientoObra) =>
              obra.keyCatTipoObra === this.OBRA_EN_PROCESO
          )
        )
      )
      .toPromise();
    this.informacionObrasLevantamientoCopia =
      this.informacionObrasLevantamiento;
    this.obrasCargadas = true;
  }

  public obtenerInformacionObra(
    infoWindow: InfoWindow,
    obra: LevantamientoObra
  ) {
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
      this.obraMarkerSeleccionada = [];
    }
    this.obraMarkerSeleccionada = this.informacionObras.filter(
      (datosObra: ObraDTO) => datosObra.obra.keyLevantamientoObra === obra.key
    );
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    if (this.obraMarkerSeleccionada.length > 0) {
      this.infoWindowAbierto = true;
      this.mostrarInformacionEnInfowindow = true;
    } else {
      this.infoWindowAbierto = true;
      this.mostrarInformacionEnInfowindow = false;
    }
  }

  public obtenerNombreCarpeta(keyCatCarpeta: string): string {
    return this.catCarpetas.find(
      (carpeta: ElementoCatalogo) => carpeta.key === keyCatCarpeta
    ).nombre;
  }

  public obtenerNombreSeccion(keyCatSeccion: string): string {
    return this.catSecciones.find(
      (seccion: ElementoCatalogo) => seccion.key === keyCatSeccion
    ).nombre;
  }

  public async descargarKML(obraSeleccionada: ObraDTO) {
    this.datosObra = await this.capaService
      .findByKeyLevantamientoObra(obraSeleccionada.obra.keyLevantamientoObra)
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
            )
          )
        ),
        take(1)
      )
      .toPromise();
    console.log("hola", this.datosObra[0].coordenadas);
    this.kmlUtils.descargarKml(this.datosObra[0].coordenadas);
  }

  public async descargarKMLPersonalizado(obra: Obra) {
    this.datosObra = await this.capaService
      .findByKeyLevantamientoObra(obra.keyLevantamientoObra)
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
            )
          )
        ),
        take(1)
      )
      .toPromise();
    this.kmlUtils.descargarKml(this.datosObra[0].coordenadas);
  }

  public async obtenerPolylines(obraLevantamiento: LevantamientoObra) {
    this.loaderService.activarLoaderScreen();
    await this.usuarioService
      .findByKey(obraLevantamiento.keyUsuarioLevantamiento)
      .pipe(
        take(1),
        concatMap((usuarioLevantamiento: Usuario) =>
          this.usuarioService
            .findByKey(obraLevantamiento.keyUsuarioAprobacion)
            .pipe(
              take(1),
              map((usuarioAprobo: Usuario) => {
                let datosObra: LevantamientoSeleccionadoDTO = {};
                datosObra.direccionAdjunta = this.catDireccionesAdjuntas.find(
                  (direccionAdjunta: ElementoCatalogo) =>
                    direccionAdjunta.key ===
                    obraLevantamiento.keyCatDireccionAdjunta
                );
                datosObra.tipoObra = this.catTipoObra.find(
                  (tipoObra: ElementoCatalogo) =>
                    tipoObra.key === obraLevantamiento.keyCatTipoObra
                );
                datosObra.estado = this.catEstados.find(
                  (estado: Estado) =>
                    estado.key === obraLevantamiento.keyCatEstado
                );
                datosObra.tipoLevantamiento = this.catTipoLevantamiento.find(
                  (tipoLevantamiento: ElementoCatalogo) =>
                    tipoLevantamiento.key ===
                    obraLevantamiento.keyCatTipoLevantamiento
                );
                datosObra.usuarioAprobo = usuarioAprobo;
                datosObra.usuarioLevantamiento = usuarioLevantamiento;
                datosObra.levObra = obraLevantamiento;
                return datosObra;
              }),
              concatMap((levSelDTO: LevantamientoSeleccionadoDTO) =>
                this.capaService
                  .findByKeyLevantamientoObra(levSelDTO.levObra.key)
                  .pipe(
                    take(1),
                    concatMap((capas: Capa[]) =>
                      from(capas).pipe(
                        concatMap((capa: Capa) =>
                          this.segmentoService.findByKeyCapa(capa.key).pipe(
                            take(1),
                            map((segmentos: Segmento[]) => {
                              let longitudSegmentos: number = 0;
                              segmentos.forEach((segmento: Segmento) => {
                                let path: Array<google.maps.LatLng> =
                                  Array.from(
                                    segmento.coordenadas,
                                    (c: Coordenada) =>
                                      new google.maps.LatLng(
                                        c.latitud,
                                        c.longitud
                                      )
                                  );
                                let longitudSegmento: number =
                                  google.maps.geometry.spherical.computeLength(
                                    path
                                  );
                                longitudSegmentos += parseFloat(
                                  longitudSegmento.toFixed(2)
                                );
                              });
                              let capaSegmentos: CapaSegmentosDTO = {
                                capa,
                                segmentos: segmentos.map(
                                  (segmento: Segmento) => ({
                                    ...segmento,
                                    nombreColor: this.catColores.find(
                                      (e: ElementoCatalogo) =>
                                        e.key === segmento.keyCatColor
                                    ).nombre,
                                  })
                                ),
                                nombreCapa: this.catCapas.find(
                                  (e: ElementoCatalogo) =>
                                    e.key === capa.keyCatCapa
                                ).nombre,
                                longitudSegmentos,
                              };
                              return capaSegmentos;
                            })
                          )
                        ),
                        toArray()
                      )
                    ),
                    map(
                      (capasSegmentos: CapaSegmentosDTO[]) =>
                        ({
                          ...levSelDTO,
                          capasSegmentos,
                        } as LevantamientoSeleccionadoDTO)
                    )
                  )
              ),
              concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) =>
                this.archivoCoordenadaService
                  .findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key)
                  .pipe(
                    take(1),
                    map((archivos: ArchivoCoordenada[]) => {
                      datosObraSeleccionada.capasSegmentos.forEach(
                        (capaSegmentos: CapaSegmentosDTO) => {
                          capaSegmentos.segmentos.forEach(
                            (segmento: Segmento) => {
                              segmento.coordenadas.forEach(
                                (coordenada: Coordenada, indice: number) => {
                                  let archivosEncontrados: ArchivoCoordenada[] =
                                    archivos.filter(
                                      (a: ArchivoCoordenada) =>
                                        a.keySegmento === segmento.key &&
                                        a.keyCoordenada === indice.toString()
                                    );
                                  if (archivosEncontrados.length > 0) {
                                    coordenada.archivos = archivosEncontrados;
                                  } else {
                                    coordenada.archivos = [];
                                  }
                                }
                              );
                            }
                          );
                          capaSegmentos.mostrarCapa = true;
                          switch (capaSegmentos.capa.keyCatCapa) {
                            case this.CAPA_PROYECTO_PROCESO:
                              capaSegmentos.zIndex = 10;
                              break;
                            case this.CAPA_PROYECTO_PLANEACION:
                              capaSegmentos.zIndex = 10;
                              break;
                            case this.CAPA_META_ACTUAL:
                              capaSegmentos.zIndex = 20;
                              break;
                            case this.CAPA_COMPLETADO:
                              capaSegmentos.zIndex = 30;
                              break;
                            case this.CAPA_ESTRUCTURA:
                              capaSegmentos.zIndex = 40;
                              break;
                          }
                        }
                      );
                      // Se crea el arreglo de avances. Cada avance tiene su propia fecha y un arreglo de segmentos. Se agrupan segmentos por fecha
                      //  Ademas, ese arreglo de segmentos tiene un calculo con la suma de todas sus longitudes.
                      let capaCompletado: CapaSegmentosDTO =
                        datosObraSeleccionada.capasSegmentos.find(
                          (capaSegmentos: CapaSegmentosDTO) =>
                            capaSegmentos.capa.keyCatCapa ===
                            this.CAPA_COMPLETADO
                        );
                      let avances: AvanceDTO[] = [];
                      if (capaCompletado) {
                        let mapaFechas = new Map<number, Segmento[]>();
                        capaCompletado.segmentos.forEach(
                          (segmento: Segmento) => {
                            let segmentos: Segmento[] = mapaFechas.get(
                              segmento.fechaRegistro
                                ? segmento.fechaRegistro
                                : segmento.fechaCreacion
                            );
                            if (!segmentos) {
                              segmentos = [];
                            }
                            segmentos.push(segmento);
                            mapaFechas.set(
                              segmento.fechaRegistro
                                ? segmento.fechaRegistro
                                : segmento.fechaCreacion,
                              segmentos
                            );
                          }
                        );

                        mapaFechas.forEach(
                          (segmentos: Segmento[], fecha: number) => {
                            let longitudSegmentos: number = 0;
                            segmentos.forEach((segmento: Segmento) => {
                              let path: Array<google.maps.LatLng> = Array.from(
                                segmento.coordenadas,
                                (c: Coordenada) =>
                                  new google.maps.LatLng(c.latitud, c.longitud)
                              );
                              let longitudSegmento: number =
                                google.maps.geometry.spherical.computeLength(
                                  path
                                );
                              longitudSegmentos += parseFloat(
                                longitudSegmento.toFixed(2)
                              );
                            });

                            let avance: AvanceDTO = {
                              capa: capaCompletado.capa,
                              nombreCapa: capaCompletado.nombreCapa,
                              zIndex: capaCompletado.zIndex,
                              mostrarCapa: capaCompletado.mostrarCapa,
                              fecha,
                              segmentos,
                              longitudSegmentos,
                            };

                            avances.push(avance);
                          }
                        );
                      }
                      datosObraSeleccionada.avances = avances;

                      return datosObraSeleccionada;
                    })
                  )
              ),
              concatMap((datosObraSeleccionada: LevantamientoSeleccionadoDTO) =>
                this.obraService
                  .findByKeyLevantamientoObra(datosObraSeleccionada.levObra.key)
                  .pipe(
                    take(1),
                    map(
                      (obra: Obra) =>
                        ({
                          ...datosObraSeleccionada,
                          obra,
                        } as LevantamientoSeleccionadoDTO)
                    )
                  )
              ),
              take(1)
            )
        )
      )
      .toPromise()
      .then((datosObraSeleccionada: LevantamientoSeleccionadoDTO) => {
        this.elementosObra = datosObraSeleccionada;
        this.estadoRouteService.mostrarBtnRetroceder$.next(false);
        this.estadoRouteService.mostrarBtnRegresarDetalleObra$.next(true);
        this.estadoRouteService.detalleObraProceso$.next(true);
        this.loaderService.desactivarLoaderScreen();
      });
  }

  async ngOnChanges(): Promise<void> {
    await this.mapsAPILoader.load();
    if (this.map) {
      //Se valida que el mapa este pintado en pantalla para poder centrar las polylines
      this.mapUtils.centrarArregloDePolylines(
        this.map,
        this.crearArregloPolylines(this.elementosObra.capasSegmentos)
      );
    }
    this.iconoInicioFin = {
      url: "../../../../../assets/img/iconos/marker-red.png",
      scaledSize: {
        width: 25,
        height: 25,
      },
      labelOrigin: new google.maps.Point(0, 0),
    };
    this.cd.detectChanges();
  }

  public abrirModalGaleria(archivosSeleccionados: ArchivoCoordenada[]) {
    this.archivosSeleccionados = archivosSeleccionados;
    this.refModalGaleria = this.ngbModalService.open(this.modalGaleria, {
      size: "lg",
      centered: true,
      windowClass: "modal-lev-web",
      backdrop: "static",
      keyboard: false,
    });
  }

  // public regresarVistaMapaObras() {
  //   this.mostrarMapaObras = false;
  // }

  public centrarMapa() {
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.elementosObra.capasSegmentos)
    );
  }

  public mouseOver(event: any, infoWindow: InfoWindow, avance: AvanceDTO): any {
    this.coordenadaInfoWindow = {
      latitud: event.latLng.lat(),
      longitud: event.latLng.lng(),
    };
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
    }
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    this.infoWindowAbierto = true;
    this.colorSegmentosSeleccionados = this.COLOR_PARA_RESALTAR;
    setTimeout(() => {
      this.avanceSeleccionado = avance;
      this.cd.detectChanges();
    }, 10);
  }

  public infoWindowClose(): void {
    if (this.avanceSeleccionado && this.infoWindowAbierto) {
      this.colorSegmentosSeleccionados = this.hexColorCapaCompletado;
    }
    this.avanceSeleccionado = null;
    this.infoWindowAbierto = false;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 10);
  }

  public onPropertyChange(valor: boolean, keyCatCapa: string): void {
    if (keyCatCapa === this.CAPA_COMPLETADO) {
      this.elementosObra.avances.forEach((avance: AvanceDTO) => {
        avance.mostrarCapa = valor;
      });
    }

    this.elementosObra.capasSegmentos.forEach(
      (capaSegmentos: CapaSegmentosDTO) => {
        if (capaSegmentos.capa.keyCatCapa === keyCatCapa) {
          capaSegmentos.mostrarCapa = valor;
        }
      }
    );
  }
  public mapReady(event: any): void {
    this.map = event;
    this.mapUtils.centrarArregloDePolylines(
      this.map,
      this.crearArregloPolylines(this.elementosObra.capasSegmentos)
    );
    this.coordenadaInicial =
      this.mapUtils.obtenerCoordenadaInicialArregloPolylines(
        this.crearArregloPolylineProyecto()
      );
    this.coordenadaFinal = this.mapUtils.obtenerCoordenadaFinalArregloPolylines(
      this.crearArregloPolylineProyecto()
    );
  }

  public crearArregloPolylines(capasSegmentos: CapaSegmentosDTO[]): any {
    let coordenadas: Array<Coordenada[]> = new Array<Coordenada[]>();
    capasSegmentos.forEach((capaSegmento) => {
      capaSegmento.segmentos.forEach((segmento: Segmento) => {
        coordenadas.push(segmento.coordenadas);
      });
    });
    return coordenadas.map((coordenadas: Coordenada[]) =>
      this.crearPolyline(coordenadas)
    );
  }

  public crearArregloPolylineProyecto(): Array<Coordenada[]> {
    let capaProyecto: CapaSegmentosDTO = this.elementosObra.capasSegmentos.find(
      (capa: CapaSegmentosDTO) =>
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PROCESO ||
        capa.capa.keyCatCapa === this.CAPA_PROYECTO_PLANEACION
    );
    let segmentos: Array<Coordenada[]> = capaProyecto.segmentos.map(
      (segmento: Segmento) => segmento.coordenadas
    );
    return segmentos;
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map((p) => ({
        lat: p.latitud,
        lng: p.longitud,
      })),
    };
  }

  public cambiarCapaFederales(nombreCapa: string) {
    if (this.elementosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === "Completado") {
        return "Terminado";
      } else if (nombreCapa === "Meta actual") {
        return `Programado ${this.anioActual}`;
      } else if (nombreCapa === "Proyecto") {
        return "Faltante";
      } else {
        return nombreCapa;
      }
    } else {
      return nombreCapa;
    }
  }

  public cambiarCapaColorFederales(
    nombreCapa: string,
    colorCapaOriginal: string
  ) {
    if (this.elementosObra.direccionAdjunta.key === this.CARRETERAS_FEDERALES) {
      if (nombreCapa === "Proyecto") {
        return this.catColores.find((e: ElementoCatalogo) => e.key === "3")
          .nombre;
      } else {
        return colorCapaOriginal;
      }
    } else {
      return colorCapaOriginal;
    }
  }

  abrirReporteador(keyLevantamiento: string) {
    // window.location.href = `http://198.37.117.136/Default.aspx?keyLevantamiento=${keyLevantamiento}`;
    window.open(
      `https://198.37.117.136/2021/ficha2021.aspx?keyLevantamiento=${keyLevantamiento}`,
      "_blank"
    );
  }
  public ngOnDestroy(): void {
    this.estadoRouteService.detalleObraProceso$.next(false);
    this.estadoRouteService.mostrarBtnRegresarDetalleObra$.next(false);
    if (this.suscripcionPolylines) {
      this.suscripcionPolylines.unsubscribe();
    }
  }
}
